import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import userbase from 'userbase-js'
import { AccountFields } from './register/AccountFields'
import { SafetyFields } from './register/SafetyFields'
import { VaccineFields } from './register/VaccineFields'

import { Button } from '../components/buttons'

export const Register = ({ ready, setUser }) => {
  const history = useHistory()

  const [regForm, setRegForm] = useState({
    username: '',
    password: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    eatOutside: 'frequently',
    outdoorsHang: 'frequently',
    indoorsHang: 'frequently',
    mask: 'always',
    travel: 'yes',
    groceries: 'yes',
    transport: 'yes',
    vaccinePlan: 'all',
    vaccineStatus: 'yes',
  })

  const [currentStep, setCurrentStep] = useState(1)

  if (!ready) {
    return null
  }

  const handleRegInputChange = (event) =>
    setRegForm({ ...regForm, [event.target.name]: event.target.value })

  const handleRegSubmit = (event) => {
    event.preventDefault()
    if (regForm.username && regForm.password)
      userbase
        .signUp({
          username: regForm.username,
          password: regForm.password,
          email: regForm.email,
          profile: {
            firstName: regForm.firstName,
            lastName: regForm.lastName,
            phone: regForm.phone,
            eatOutside: regForm.eatOutside,
            outdoorsHang: regForm.outdoorsHang,
            indoorsHang: regForm.indoorsHang,
            mask: regForm.mask,
            travel: regForm.travel,
            groceries: regForm.groceries,
            transport: regForm.transport,
            vaccinePlan: regForm.vaccinePlan,
            vaccineStatus: regForm.vaccineStatus,
          },
          rememberMe: 'local',
        })
        .then((ur) => {
          setUser(ur)
          history.replace({ pathname: '/', state: { newAccount: true } })
        })
        .catch((err) => alert(err))
  }

  const isFormValid = () => {
    let isValid = true
    const fields = [...document.getElementsByTagName('input')]
    fields.forEach((field) => {
      if (isValid === true) {
        const isFieldValid = field.reportValidity()
        if (isFieldValid === false) {
          isValid = false
        }
      }
    })

    return isValid
  }

  const showNextFields = () => {
    if (isFormValid()) {
      setCurrentStep(currentStep + 1)
    }
  }

  return (
    <div className="container-md py-64">
      <h2 className="sr-only">Register</h2>
      <form onSubmit={handleRegSubmit} id="register">
        <AccountFields
          form={regForm}
          handleChange={handleRegInputChange}
          currentStep={currentStep}
        />
        <SafetyFields
          handleChange={handleRegInputChange}
          currentStep={currentStep}
        />
        <VaccineFields
          handleChange={handleRegInputChange}
          currentStep={currentStep}
        />
      </form>
      {currentStep === 3 ? (
        <Button
          className="bg-purple-light text-white rounded-10"
          type="submit"
          value="Submit"
          form="register"
          key={`form-button-${currentStep}`}
        >
          Create Account
        </Button>
      ) : (
        <Button
          className="bg-purple-light text-white rounded-10"
          onClick={showNextFields}
          key={`form-button-${currentStep}`}
        >
          Save and Continue
        </Button>
      )}
    </div>
  )
}
